import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'

export const generateUUId = () => {
    return uuidv4() + 'rs'+(Date.now())
}

export const generateEventId = () => {
    return moment().format('YYYY-MM-DD HH:mm:ss')
}